/** Offline fallback when GET /public/legal fails (mirrors backend config/legal.php). */

const COMPANY = 'cbonline';
const EMAIL = 'support@cbonline.co.tz';
const PHONE = '0711416873';
const JURISDICTION = 'United Republic of Tanzania';

function apply(text) {
  return String(text)
    .replace(/:company/g, COMPANY)
    .replace(/:email/g, EMAIL)
    .replace(/:phone/g, PHONE)
    .replace(/:jurisdiction/g, JURISDICTION);
}

function formatDoc(doc) {
  return {
    version: doc.version,
    title: doc.title,
    lastUpdated: doc.lastUpdated,
    sections: (doc.sections || []).map((s) => ({
      heading: s.heading,
      body: apply(s.body),
    })),
  };
}

const TERMS_RAW = {
  version: '2026-05-28',
  title: 'Terms of Service',
  lastUpdated: '28 May 2026',
  sections: [
    {
      heading: '1. Agreement',
      body: 'By creating an account you agree to these Terms of Service with :company ("we", "us"). If you do not agree, do not register or use the service.',
    },
    {
      heading: '2. Service',
      body: ':company provides cloud business software (inventory, POS, billing, reporting, and related modules) for your organisation. Features depend on your subscription plan and business type.',
    },
    {
      heading: '3. Your account',
      body: 'You must provide accurate business and contact information. You are responsible for keeping your password secure and for all activity under your account. Notify us immediately of unauthorised use.',
    },
    {
      heading: '4. Acceptable use',
      body: 'You may not use the service for unlawful purposes, to store malicious code, to interfere with other users, or to attempt unauthorised access to our systems or data belonging to other tenants.',
    },
    {
      heading: '5. Subscription & payments',
      body: 'Trial and paid plans are described at signup. Fees, renewal, and suspension for non-payment follow the plan you select. We may change pricing with reasonable notice before your next billing period.',
    },
    {
      heading: '6. Data & availability',
      body: 'We process your business data to provide the service. We aim for high availability but do not guarantee uninterrupted access. Scheduled maintenance may occur with notice where practical.',
    },
    {
      heading: '7. Limitation of liability',
      body: 'To the fullest extent permitted by law in :jurisdiction, we are not liable for indirect or consequential losses. Our total liability for any claim is limited to fees paid by you in the twelve (12) months before the claim.',
    },
    {
      heading: '8. Termination',
      body: 'You may stop using the service at any time. We may suspend or terminate accounts that breach these terms or applicable law. Upon termination, access ends; export your data before closure where the product allows.',
    },
    {
      heading: '9. Governing law',
      body: 'These terms are governed by the laws of :jurisdiction. Disputes should first be raised with :email.',
    },
  ],
};

const PRIVACY_RAW = {
  version: '2026-05-28',
  title: 'Privacy Policy',
  lastUpdated: '28 May 2026',
  sections: [
    {
      heading: '1. Who we are',
      body: ':company ("we") operates the cbonline business platform. This policy explains how we collect and use personal data when you register and use our service.',
    },
    {
      heading: '2. Data we collect',
      body: 'We collect information you provide (name, email, business name, phone, address, branch location), account credentials (stored hashed), usage and audit logs, and business records you enter (sales, stock, customers, etc.).',
    },
    {
      heading: '3. How we use data',
      body: 'We use data to provide and improve the service, authenticate users, process subscriptions, send service-related messages, prevent fraud, and comply with legal obligations.',
    },
    {
      heading: '4. Sharing',
      body: 'We do not sell your personal data. We may share data with infrastructure providers under contract, or when required by law or to protect rights and safety.',
    },
    {
      heading: '5. Security',
      body: 'We apply technical and organisational measures appropriate to a cloud business application, including access controls and encryption in transit. No system is completely secure; protect your credentials.',
    },
    {
      heading: '6. Retention',
      body: 'We retain data while your account is active and as needed for legal, accounting, or dispute purposes. You may request deletion subject to lawful retention requirements.',
    },
    {
      heading: '7. Your rights',
      body: 'You may access, correct, or request deletion of your personal data by contacting :email. You may withdraw consent where processing is consent-based, without affecting prior lawful processing.',
    },
    {
      heading: '8. Contact',
      body: 'Questions about privacy: :email or :phone.',
    },
  ],
};

export const FALLBACK_LEGAL = {
  companyName: COMPANY,
  contactEmail: EMAIL,
  contactPhone: PHONE,
  jurisdiction: JURISDICTION,
  terms: formatDoc(TERMS_RAW),
  privacy: formatDoc(PRIVACY_RAW),
};
